module.exports = __webpack_public_path__ + "gb-wls.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gb-wls.svg
// module id = 1162
// module chunks = 0